import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import Banner from '../../Components/Banner'

import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'
const relatedService = [
    {
        id: 1,
        title: "Enterprise Applications & ERP",
        description: "Bring all your business processes together with simple, scalable ERP systems that make work easier, faster, and more organized.",
        image: "/assets/product/p1.png",
        link: "/enterprise-applications-erp"
    },
    {
        id: 2,
        title: "ServiceNow Digital Workflows",
        description: "Simplify IT, HR, and customer support by automating everyday tasks with smart workflows on one easy, connected platform.",
        image: "/assets/product/p3.png",
        link: "/servicenow-digital-workflows"
    },
    {
        id: 3,
        title: "Embedded Systems & Industrial",
        description: "We design secure, real-time embedded solutions for industrial IoT, automation, and smart devices that help businesses run smoother, work smarter, and grow with confidence.",
        image: "/assets/product/p4.png",
        link: "/embedded-systems-industrial"
    },
    {
        id: 4,
        title: "Quality Engineering & Performance",
        description: "Deliver smooth, reliable software with automated testing and performance checks, ensuring quality, stability, and a great user experience every time.",
        image: "/assets/product/p2.png",
        link: "/quality-engineering-performance"
    }
];

const data = [
    {
        id: 1,
        category: "TALENT STRATEGY",
        title: "Staff Augmentation vs. Managed Services: Choosing the Right Model",
        link: "#"
    },
    {
        id: 2,
        category: "GLOBAL TEAMS",
        title: "Building High-Performing Distributed Engineering Teams",
        link: "#"
    },
    {
        id: 3,
        category: "COST EFFICIENCY",
        title: "Reducing TCO by up to 40% with Offshore Development Centers",
        link: "#"
    },
    {
        id: 4,
        category: "AGILE STAFFING",
        title: "Scaling Your Workforce on Demand: A Guide for CTOs",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "Dedicated Development Teams",
        category: "service",
        desc: "Extend your team with dedicated, self-managed engineers who feel like a true part of your in-house team, aligned with your culture, goals, and way of working.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/",
    },
    {
        id: 2,
        title: "Contract Staffing (PAN India & Global)",
        category: "service",
        desc: "Flexible staffing that helps you easily scale your team up or down whenever your project needs change, quickly and smoothly.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/staff-augmentation",
    },
    {
        id: 3,
        title: "Offshore Development Center (ODC)",
        category: "service",
        desc: "Create a smart, cost-effective innovation hub with full support, helping your business run smoothly, grow faster, and scale confidently.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "Project-Based Delivery",
        category: "service",
        desc: "We take full responsibility for every milestone and deliverable, ensuring focused execution, quality results, and smooth project delivery every time.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/",
    },
    {
        id: 5,
        title: "Recruitment & Talent Solutions",
        category: "service",
        desc: "We help you find, carefully evaluate, and hire the top 1% of global tech talent with ease and confidence.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/",
    },
]

function ManagedServices() {
    return (
        <div>
            <Helmet>
    <title>
        Managed IT Services & Staff Augmentation | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides managed IT services, dedicated development teams, staff augmentation, offshore development centers, project-based delivery, and technology talent solutions to help businesses scale efficiently."
    />

    <meta
        name="keywords"
        content="Managed IT Services, Managed Services, IT Staff Augmentation, Staff Augmentation Services, Dedicated Development Teams, Offshore Development Center, ODC Services, Contract Staffing Services, Project Based Software Development, IT Talent Solutions, Technology Staffing Services, Dedicated Software Development Team, Global IT Staffing, Managed Technology Services"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/managed-services"
    />

    <meta
        property="og:title"
        content="Managed IT Services & Staff Augmentation | Mobikode"
    />

    <meta
        property="og:description"
        content="Scale your technology capabilities with Mobikode's managed services and staffing solutions. Access dedicated engineers, flexible contract teams, offshore development centers, and project-based delivery."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/managed-services"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c8.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Managed IT Services & Staff Augmentation | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's managed services, dedicated development teams, contract staffing, ODC solutions, project delivery, and technology recruitment services."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c8.png"
    />
</Helmet>
            <AiHero title="Managed Services" imgData="/assets/what/c8.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="Managed Services"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] flex flex-col justify-center
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                In today’s fast-changing tech world, having the right people at the right time can make all the difference. At Mobikode, we make scaling your team simple and stress-free. Through our Managed Services and Staff Augmentation, you get quick access to skilled, pre-vetted professionals and dedicated development teams who work as an extension of your own. We help you stay flexible, move faster, and focus on what truly matters building and growing your product.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Setting Up a 50-Member Offshore Development Center for a US Healthcare Firm</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Rapid Staff Augmentation for a Critical Banking Transformation...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Managing Global IT Operations with 24/7 Support Teams...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Mobikode Staffing Advantage"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode Talent Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we’re not just another staffing agency, we become your extended hiring partner. We take time to understand your needs and carefully screen talent so you get engineers who are skilled, reliable, and aligned with your team culture. Whether you need flexible contract support or want to set up a full Offshore Development Center (ODC), we help you build strong teams that can grow with your business.  </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Managed Services" />
            <ContactSection/>
        </div>
    )
}

export default ManagedServices